module.exports = __webpack_public_path__ + "static/e-shop-112d2fe0d6a178e52b716bbc15896da2.webp";